module.exports = __webpack_public_path__ + "static/media/S.966c4cb7.jpg";